import { useState, useEffect } from 'react';
import NaviBar from '../NaviBar/NaviBar';
import SearchBar from '../NaviBar/SearchBar';
import Cookies from 'js-cookie';
import zoomIn from '../../Icons/right-out.svg';
import zoomOut from '../../Icons/left-in.svg';
import { currencyStyle } from '../../services/methods';
import { currencyOptions } from '../../staticData/options';
import addIcon from '../../Icons/add-quantity-icon.svg';
import decreIcon from '../../Icons/decrease-qtt.svg';
import 'animate.css';
import BottomCard from '../ShoppingCart/BottomCart';
import { useTranslation } from 'react-i18next';
import buy_now from '../../Icons/buy_now.png';
import QRModal from '../items/QRModal';
import Draggable from 'react-draggable';

function arraymove(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}

function DescriptionPage(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { t } = useTranslation();
  const {
    cart,
    decreStock,
    langs,
    showCart,
    remove,
    alterquantity,
    add,
    setShowCart,
    setlangs,
    stat,
    setStat,
  } = props;

  let prods = JSON.parse(localStorage.getItem('products'));
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  symbol = symbol ? symbol : '$';
  const idx = props.i;

  //get image url from productPicture
  const newImage = [];
  prods[idx].productPictures.forEach((element) => {
    if (element !== '') {
      newImage.push(
        // `${process.env.REACT_APP_SERVER_API}/pictures/${element}/${prods[idx].referTo}`
        isLocal
          ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${element}`
          : `${process.env.REACT_APP_SERVER_API}/pictures/${element}/${prods[idx].referTo}`
      );
    }
  });

  const [pictures, setPictures] = useState(newImage);
  const [curr, setCurr] = useState(0);

  const [mainL, setMainL] = useState('en-US');
  const [show, setShow] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [active, setActive] = useState(0);
  const [more, setMore] = useState(true);
  const [more1, setMore1] = useState(true);
  const [more2, setMore2] = useState(true);
  // console.log(prods[idx]);

  const FName =
    prods[idx].name[langs] && prods[idx].name[langs] !== ''
      ? prods[idx].name[langs]
      : prods[idx].name?.en;
  const FDesc =
    prods[idx].description && prods[idx].description[langs] && prods[idx].description[langs] !== ''
      ? prods[idx].description[langs]
      : prods[idx].description?.en;
  const FKeyf =
    prods[idx].keyFeatures && prods[idx].keyFeatures[langs] && prods[idx].keyFeatures[langs] !== ''
      ? prods[idx].keyFeatures[langs]
      : prods[idx].keyFeatures?.en;
  const Fdetail =
    prods[idx].detail && prods[idx].detail[langs] && prods[idx].detail[langs] !== ''
      ? prods[idx].detail[langs]
      : prods[idx].detail?.en;
  const FSpec =
    prods[idx].specification &&
    prods[idx].specification[langs] &&
    prods[idx].specification[langs] !== ''
      ? prods[idx].specification[langs]
      : prods[idx].specification?.en;
  const FInclude =
    prods[idx].include && prods[idx].include[langs] && prods[idx].include[langs] !== ''
      ? prods[idx].include[langs]
      : prods[idx].include?.en;

  const today = new Date();

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
    console.log(prods);
  }, []);

  //count description page
  useEffect(() => {
    const index = stat?.prod.findIndex((item) => item._id === prods[idx]._id);
    if (index >= 0) {
      stat.prod[index].detail = stat.prod[index].detail += 1;
    } else {
      stat.prod.push({
        _id: prods[idx]._id,
        name: prods[idx].name?.en,
        detail: 1,
        specs: 0,
        includes: 0,
        add_to_cart: 0,
        conv: 0,
      });
    }
    setStat(stat);
  }, []);

  //count spec page
  useEffect(() => {
    const index = stat?.prod.findIndex((item) => item._id === prods[idx]._id);
    if (index >= 0) {
      if (active !== 0) {
        if (active === 1) {
          stat.prod[index].specs = stat.prod[index].specs += 1;
        }
        if (active === 2) {
          stat.prod[index].includes = stat.prod[index].includes += 1;
        }
        setStat(stat);
      }
    }
    console.log(stat);
  }, [active]);

  useEffect(() => {
    if (props.cart.length > 0) {
      const index = props.cart?.findIndex((item) => item.id === prods[idx]._id);
      if (index >= 0) {
        setQuantity(props.cart[index].quantity);
      } else {
        setQuantity(0);
      }
    } else {
      setQuantity(0);
    }
    return () => {};
  }, [cart]);

  const clickImg = (index) => {
    const array = [...pictures];
    arraymove(array, index, 0);
    console.log(array);
    setPictures(array);
  };

  function imageSlider(e) {
    return <img alt="" src={newImage[0]} />;
  }

  const leftFunction = () => {
    const index = curr === 0 ? newImage.length - 1 : curr - 1;
    setCurr(index);
  };

  const rightFunction = () => {
    const index = curr >= newImage.length - 1 ? 0 : curr + 1;
    setCurr(index);
  };

  function calculateItemPrice() {
    if (prods[idx].buyX) {
      console.log('11111111111');
      if (prods[idx].percentage) {
        const details = `<p class="card-product-title"><span style="color: red; font-size: 1.5rem;">${t(
          'Buy'
        ).toUpperCase()} ${prods[idx].buyX} ${t('Or').toUpperCase()} ${t('More').toUpperCase()} ${
          prods[idx].name[langs]
        }, ${t('Get').toUpperCase()} ${prods[idx].amount * 100}% ${t(
          'Off'
        ).toUpperCase()}! </span></p>`;
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(
                langs,
                symbol,
                prods[idx].price.toLocaleString(mainL, currencyOptions)
              )}
            </span>
            &nbsp;&nbsp;
          </div>
        );
      } else {
        return (
          <div>
            <span style={{ margin: 0 }}>
              {currencyStyle(
                langs,
                symbol,
                prods[idx].price.toLocaleString(mainL, currencyOptions)
              )}
            </span>
            &nbsp;&nbsp;{' '}
            <span style={{ margin: 0, color: 'red', textDecoration: 'underline dotted' }}>
              {t('Promo')}
            </span>
          </div>
        );

        // return <span>${props.price} - <span style={{color: 'red'}}>{t('Promo')}!</span></span>
      }
    } else if (prods[idx].discountedPrice && prods[idx].discountedPrice !== prods[idx].price) {
      return (
        <div>
          <span>
            <del>
              {currencyStyle(
                langs,
                symbol,
                prods[idx].price?.toLocaleString(mainL, currencyOptions)
              )}
            </del>

            <span style={{ color: 'red' }}>
              &nbsp;&nbsp;
              {currencyStyle(
                langs,
                symbol,
                prods[idx].discountedPrice?.toLocaleString(mainL, currencyOptions)
              )}
            </span>
          </span>
        </div>
      );
    } else {
      return (
        <div>
          {currencyStyle(langs, symbol, prods[idx].price.toLocaleString(mainL, currencyOptions))}
        </div>
      );
    }
  }

  // const calculateProductPrice = () => {
  //   const originPrice = (
  //     <del>
  //       {currencyStyle(
  //         langs,
  //         symbol,
  //         parseFloat((prods[idx].price * quantity).toFixed(2))
  //       ).toLocaleString(mainL, currencyOptions)}
  //     </del>
  //   );
  //   if (prods[idx]?.buyX > 1) {
  //     if (quantity === 1) {
  //       return `$${prods[idx].price}`;
  //     } else if (quantity > 1) {
  //       if (quantity % prods[idx].buyX === 0) {
  //         if (prods[idx].percentage == true) {
  //           return (
  //             <span>
  //               {originPrice}
  //               <span style={{ color: 'red', marginLeft: '0.5em' }}>
  //                 {currencyStyle(
  //                   langs,
  //                   symbol,
  //                   parseFloat((prods[idx].discountedPrice * quantity).toFixed(2)).toLocaleString(
  //                     mainL,
  //                     currencyOptions
  //                   )
  //                 )}
  //               </span>
  //             </span>
  //           );
  //         } else {
  //           return (
  //             <span>
  //               {originPrice}
  //               <span style={{ color: 'red', marginLeft: '0.5em' }}>
  //                 {currencyStyle(
  //                   langs,
  //                   symbol,
  //                   parseFloat(
  //                     (
  //                       prods[idx].price * quantity -
  //                       prods[idx].discount * Math.floor(quantity / prods[idx].buyX)
  //                     ).toFixed(2)
  //                   ).toLocaleString(mainL, currencyOptions)
  //                 )}
  //               </span>
  //             </span>
  //           );
  //         }
  //       } else {
  //         if (quantity < prods[idx].buyX) {
  //           return currencyStyle(
  //             langs,
  //             symbol,
  //             parseFloat((prods[idx].price * quantity).toFixed(2)).toLocaleString(
  //               mainL,
  //               currencyOptions
  //             )
  //           );
  //         } else {
  //           if (prods[idx].percentage == true) {
  //             return (
  //               <span>
  //                 {originPrice}
  //                 <span style={{ color: 'red', marginLeft: '0.5em' }}>
  //                   {currencyStyle(
  //                     langs,
  //                     symbol,
  //                     parseFloat((prods[idx].discountedPrice * quantity).toFixed(2)).toLocaleString(
  //                       mainL,
  //                       currencyOptions
  //                     )
  //                   )}
  //                 </span>
  //               </span>
  //             );
  //           } else {
  //             return (
  //               <span>
  //                 {originPrice}
  //                 <span style={{ color: 'red', marginLeft: '0.5em' }}>
  //                   {currencyStyle(
  //                     langs,
  //                     symbol,
  //                     parseFloat(
  //                       (
  //                         prods[idx].price *
  //                           prods[idx].buyX *
  //                           Math.floor(quantity / prods[idx].buyX) -
  //                         prods[idx].discount +
  //                         prods[idx].price *
  //                           (quantity - prods[idx].buyX * Math.floor(quantity / prods[idx].buyX))
  //                       ).toFixed(2)
  //                     ).toLocaleString(mainL, currencyOptions)
  //                   )}
  //                 </span>
  //               </span>
  //             );
  //           }
  //         }
  //       }
  //     } else return currencyStyle(langs, symbol, 0);
  //   } else {
  //     if (prods[idx].discount > 0 && quantity > 0) {
  //       return (
  //         <span>
  //           {originPrice}
  //           <span style={{ color: 'red', marginLeft: '0.5em' }}>
  //             {currencyStyle(
  //               langs,
  //               symbol,
  //               parseFloat((prods[idx].discountedPrice * quantity).toFixed(2)).toLocaleString(
  //                 mainL,
  //                 currencyOptions
  //               )
  //             )}
  //           </span>
  //         </span>
  //       );
  //     } else if (prods[idx].discount > 0 && quantity == 0) return `$0`;
  //     else
  //       return currencyStyle(
  //         langs,
  //         symbol,
  //         parseFloat((prods[idx].price * quantity).toFixed(2)).toLocaleString(
  //           mainL,
  //           currencyOptions
  //         )
  //       );
  //   }
  // };

  const getPrice = () => {
    if (prods[idx].discountedPrice && prods[idx].buyX > 1) return prods[idx].price;
    else if (prods[idx].discountedPrice) return prods[idx].discountedPrice;
    else return prods[idx].price;
  };

  const splitTheContent = (content) => {
    if (content) {
      const array = content.split(';');
      const result = array.map((e, i) => {
        return <div key={i}>{e}</div>;
      });

      return result;
    }
  };

  const addToCart = async (e) => {
    const index = props.cart?.findIndex((item) => item.id === prods[idx]._id);
    if (prods[idx].current_stock > 0) {
      props.decreStock(prods[idx], prods[idx].current_stock - 1);
      if (
        prods[idx].plan &&
        Date.parse(prods[idx].plan.start) <= today &&
        Date.parse(prods[idx].plan.end) >= today
      ) {
        // setShowp(true);
        // setmyprod(props.prod);
      }
      if (index >= 0) {
        props.alterquantity({ id: prods[idx]._id }, cart[index].quantity + 1);
      } else {
        props.add({
          idx: parseInt(prods[idx].idx),
          id: prods[idx]._id,
          _id: prods[idx]._id,
          key: prods[idx]._id,
          upc: prods[idx]?.upc,
          name: prods[idx].name,
          title: prods[idx].name,
          promo: prods[idx].promo,
          price: prods[idx].price,
          discount: prods[idx].discount ? prods[idx].discount : 0,
          percentage: prods[idx].percentage,
          discountedPrice: prods[idx].discountedPrice
            ? prods[idx].discountedPrice
            : prods[idx].price,
          image: prods[idx].productPictures[0],
          buyX: prods[idx].buyX ? prods[idx].buyX : 0,
          quantity: 1,
          category: prods[idx].category,
          ingredients: prods[idx].ingredients,
          referTo: prods[idx].referTo,
          prodType: prods[idx].prodType,
          current_stock: prods[idx].current_stock,
          emailCode: prods[idx].emailCode,
          addition: prods[idx].addition,
          tax_type: prods[idx].tax_type,
        });
      }
    }
  };

  const machine = JSON.parse(localStorage.getItem('machine'));
  const qrcode = machine?.themeColor?.allBrand;

  const [drag, setDrag] = useState(false);
  const [showQR, setShowQR] = useState(false);

  const QRpage = () => {
    setShowQR(true);
  };

  useEffect(() => {
    return () => {
      setDrag(true);
    };
  }, []);

  const setShowMore = () => {
    more ? setMore(false) : setMore(true);
  };
  const setShowMore1 = () => {
    more1 ? setMore1(false) : setMore1(true);
  };
  const setShowMore2 = () => {
    more2 ? setMore2(false) : setMore2(true);
  };

  const selfDecreStock = () => {
    decreStock(prods[idx], prods[idx].current_stock + 1);
    if (quantity == 1) {
      props.remove({ id: prods[idx]._id });
    } else if (quantity > 1) {
      const index = props.cart?.findIndex((item) => item.id === prods[idx]._id);
      props.alterquantity({ id: prods[idx]._id }, props.cart[index].quantity - 1);
    }
  };

  return (
    <div className="main-container">
      {showQR && (
        <QRModal
          show={showQR}
          setShow={setShowQR}
          code={qrcode}
          machine={machine}
          isLocal={isLocal}
        />
      )}
      {qrcode && (
        <Draggable
          axis="both"
          handle=".handle"
          defaultPosition={{ x: 0, y: 940 }}
          position={null}
          grid={[25, 25]}
          scale={1}
          onClick={QRpage}
          onDrag={() => {
            setDrag(true);
          }}
          onStop={() => {
            const stage = drag;
            setDrag(false);
            if (!stage) {
              QRpage();
            }
          }}
        >
          {!showQR ? (
            <div className="d-flex handle floating_button">
              <img className="" src={buy_now} alt=""></img>
            </div>
          ) : (
            <div></div>
          )}
        </Draggable>
      )}
      <div className="Navi"></div>
      <NaviBar setShowCart={setShowCart} setlangs={setlangs} cart={cart} />
      <SearchBar langs={langs} />
      {/* <Modal
        className="animate__animated animate__zoomInDownz animate__zoomInz"
        show={show}
        onHide={() => setShow(false)}
        size="xl"
        centered
      >
        {imageSlider()}
      </Modal> */}
      <div className="decription-page">
        <div className="desc-main-image-div">
          <img alt="" className="desc-main-image" src={newImage[curr]}></img>
          <div className="desc-second-image-container">
            {newImage?.length > 1 && (
              <div className="desc-second-image-div" style={{ marginRight: '-25px' }}>
                <img alt="" src={zoomIn} className="desc-zoom-icon" onClick={leftFunction}></img>
              </div>
            )}
            {/* 
            {newImage.map((e, i) => {
              if (i > curr   2) {
                return (
                  <div
                    key={i}
                    className="desc-second-image-div"
                    onClick={() => {
                      clickImg(i + 1);
                    }}
                  >
                    <img alt="" className="desc-second-image" src={pictures[i]}></img>
                  </div>
                );
              }
            })} */}
            {newImage?.length >= 1 && (
              <div
                className="desc-second-image-div"
                // onClick={() => {
                //   clickImg(i + 1);
                // }}
              >
                <img alt="" className="desc-second-image" src={pictures[curr]}></img>
              </div>
            )}

            {newImage?.length > 1 && (
              <div
                className="desc-second-image-div"
                // onClick={() => {
                //   clickImg(i + 1);
                // }}
              >
                <img
                  alt=""
                  className="desc-second-image"
                  src={pictures[curr >= newImage.length - 1 ? 0 : curr + 1]}
                ></img>
              </div>
            )}

            {newImage?.length > 1 && (
              <div className="desc-second-image-div" style={{ marginLeft: '-25px' }}>
                <img alt="" src={zoomOut} className="desc-zoom-icon" onClick={rightFunction}></img>
              </div>
            )}
          </div>
          <div className={FName ? 'desc-name-20' : 'desc-name'}>{FName}</div>
          {prods[idx].detail && <div className="desc-detail">{Fdetail}</div>}

          <div className="desc-price">{calculateItemPrice()}</div>
          {quantity === 0 ? (
            prods[idx].current_stock > 0 ? (
              <div className="view-more-button desc-addtocart" onClick={addToCart}>
                {t(`ADD TO CART`)}
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center">
                <div className="desc-product-soldout d-flex align-items-center justify-content-center">
                  <span className="desc-product-soldout-text">{t(`SOLD OUT`)}</span>
                </div>
              </div>
            )
          ) : (
            <div className="desc-product-add-remove-div d-flex align-items-center justify-content-center">
              {quantity > 0 && (
                <img
                  alt=""
                  className="desc-addtocartimage"
                  src={decreIcon}
                  onClick={selfDecreStock}
                ></img>
              )}
              {quantity > 0 && (
                <div className="desc-product-quantity d-flex align-items-center justify-content-center">
                  <span className="desc-product-quantity-text">{quantity}</span>
                </div>
              )}
              {prods[idx].current_stock > 0 ? (
                <img
                  alt=""
                  src={addIcon}
                  className="desc-addtocartimage"
                  onClick={() => {
                    addToCart();
                  }}
                ></img>
              ) : (
                <div className="desc-addtocartimage"></div>
              )}
            </div>
          )}

          <div className="desc-overview-div">
            <div
              className={active === 0 ? 'desc-active' : ''}
              onClick={() => {
                setActive(0);
              }}
            >
              <div> {t(`Overview`)}</div>
              <div className="desc-line"></div>
            </div>
            <div
              className={active === 1 ? 'desc-active' : ''}
              onClick={() => {
                setActive(1);
              }}
            >
              <div>{t(`Specifications`)}</div>
              <div className="desc-line"></div>
            </div>
            <div
              className={active === 2 ? 'desc-active' : ''}
              onClick={() => {
                setActive(2);
              }}
            >
              <div>{t(`What's Included`)}</div>
              <div className="desc-line"></div>
            </div>
          </div>

          {active === 0 && FDesc && FDesc !== '' && (
            <div>
              <div className="desc-desc-div">
                <div className="desc-desc-text">{t(`Description`)}</div>
                <div
                  // className={more ? 'desc-desc-subtext' : 'desc-desc-subtext-1'}
                  className="desc-desc-subtext"
                  onClick={setShowMore}
                >
                  {FDesc}
                </div>
              </div>
              {prods[idx].keyFeatures && FKeyf && FKeyf !== '' && (
                <div>
                  <div className="desc-desc-text">{t(`Key Features`)}</div>
                  <div
                    className={more1 ? 'desc-desc-subtext2' : 'desc-desc-subtext-1'}
                    onClick={setShowMore1}
                  >
                    {splitTheContent(FKeyf)}
                  </div>
                </div>
              )}
            </div>
          )}
          {active === 1 && prods[idx].specification && FSpec && FSpec !== '' && (
            <div>
              <div className="desc-desc-text">{t(`Specifications`)}</div>
              {prods[idx].specification && (
                <div
                  className={more2 ? 'desc-desc-subtext3' : 'desc-desc-subtext-1'}
                  onClick={setShowMore2}
                >
                  {splitTheContent(FSpec)}
                </div>
              )}
            </div>
          )}
          {active === 2 && prods[idx].include && FInclude && FInclude !== '' && (
            <div>
              <div className="desc-desc-text">{t(`What's Included`)}</div>
              {prods[idx].include && (
                <div
                  className={more2 ? 'desc-desc-subtext3' : 'desc-desc-subtext-1'}
                  onClick={setShowMore2}
                >
                  {splitTheContent(FInclude)}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <BottomCard
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={prods}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
        isLocal={isLocal}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default DescriptionPage;
